import Menu from './components/Menu';
import Home from './pages/Home';
import Settings from './pages/Settings';
import About from './pages/About';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Test from './pages/Test';
import Pin from './pages/Pin';
import React from 'react';
import { IonApp, IonRouterOutlet, IonSplitPane, setupIonicReact} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Redirect, Route } from 'react-router-dom';
import ServerService from './services/Server';
import { useEffect, useState } from 'react';
import { useAuth } from './context/AuthContext';
import { setAuthPersisted } from './services/pinUtils';
import { Environment } from "./data/Environment";
import { Buffer } from "buffer";
  
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

/* Auth */
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { resizeOutline } from 'ionicons/icons';

//const notificationsService = new NotificationsService();
setupIonicReact({ });

//export class App extends React.Component<any, any> {
const App: React.FC = () => {

  // var data;

  // var oReq = new XMLHttpRequest();
  // oReq.onload = reqListener;
  // oReq.open("get", file, true);
  // oReq.send();
  
  // function reqListener(e:any) {
  //    console.log("response:"+oReq.responseText);
  //    data = JSON.parse(oReq.responseText);
  //    console.log("data:"+data);
  // }
  // console.log(data[0]["id"]);
  // console.log(data[0]["name"]);
  // console.log(data[1]["id"]);
  // console.log(data[1]["name"]);

//   constructor(props:any, context:any) {
//     super(props, context);
// //    this.state = null;
//     // calling here
//   }

//  componentDidMount() {
//    console.log("componentDidMount()");
//    firebase.initializeApp(Environment.firebase);
    // const notificationsService = new NotificationsService();
    // notificationsService.init();

//    await notificationsService.requestPermission();
//  }
  const [isInitializing, setIsInitializing] = useState(true);
  const [url, setUrl] = useState("/page/home");
  const [pin, setPin] = useState(false);
  const [btnLogout, setBtnLogout] = useState(false);

  const server = new ServerService();

  const fetchAppInitialData = async () => {
  //  console.log("Fetching API data...");

    if (server.accounts.length===0 || server.accounts[0].name === "") {
        server.accounts[0].name = server.defaultAccount.name;
        server.accounts[0].host = server.defaultAccount.host;
        server.accounts[0].port = server.defaultAccount.port;
        server.accounts[0].username = server.defaultAccount.username;
        server.accounts[0].password = server.defaultAccount.password;
        server.accounts[0].customerKey = server.defaultAccount.customerKey;
    }

    const account = server.accounts[server.activeAcc];

    const state = {
        host:account.host,
        port:account.port,
        username:account.username,
        password:account.password,
        customerKey:account.customerKey,
        ticket:"",
        base64ticket:"",
        handed:"right",
        params:{},
        pin:"",
        logout:"",
        landingUrl:"/page/home/mytasks"
    }

    server.state = state;
    const data = {username:state.username, password:state.password}
    let res;
    try {
      res = await server.fetchWithTimeout(
            "https://"+state.host+":"+state.port+Environment.API_PREFIX+"login",
            {
              method:'POST',
              mode:'cors',
              cache:'no-cache',
              credentials:'omit',
              referrerPolicy:'no-referrer',
              headers:{'Content-Type':'application/json'},
              body:JSON.stringify(data)
            }
            ,20000
      );

//      console.log(res);

      if (res instanceof Response) {
        if (res.ok) {
          const json0 = await res.json();
//          console.dir(json0);

          if (json0.data) {
            server.state.ticket = json0.data.ticket;
            server.state.base64ticket = Buffer.from(server.state.ticket).toString('base64');
      
            let rescfg = await fetch(server.getPrefixUrl()+"mb/cfg",server.getRequest());
            if (rescfg instanceof Response) {
              if (rescfg.ok) {
                const json = await rescfg.json();
                console.log("Pin:"+json.data.pin);
                server.state.pin = json.data.pin;
                server.state.logout = json.data.logout;
              } else {
                server.state.pin = "";
                server.state.logout = "";
              }
            }
      
            window.localStorage.setItem("state", JSON.stringify(server.state));
      
            const state = server.state;
            setPin(state.pin=="1");
            setBtnLogout(state.logout=="1");
//            console.log("url:"+(state.ticket ? (state.pin=="1" ? "/page/pin" : "/page/home") : "/page/settings"));
            setUrl(state.ticket ? (state.pin=="1" ? "/page/pin" : "/page/home") : "/page/settings");
          } else {
            setPin(false);
            setBtnLogout(false);
//            console.log("url:"+(state.ticket ? "/page/home" : "/page/settings"));
            setUrl(state.ticket ? "/page/home" : "/page/settings");
          }
        }
      } else {
        console.log("Login Error:"+e);
        server.clearTicket()
        server.saveLocal();
        setPin(false);
        setBtnLogout(false);
        setUrl(state.ticket ? "/page/home" : "/page/settings");
      }
    } catch (e) {      
      console.log("Login Error:"+e);
      console.error(e);
      server.clearTicket()
      server.saveLocal();
      setPin(false);
      setBtnLogout(false);
      setUrl(state.ticket ? "/page/home" : "/page/settings");
  }

//    console.log("fetchAppInitialData Last pin:"+server.state.pin);
  };

  useEffect(() => {
    const loadData = async () => {
      await fetchAppInitialData();
      setIsInitializing(false);
    };

    loadData();

  }, []);

  return (
    <IonApp>
      {isInitializing ? (
        <div className="custom-loading-overlay">
          <div className="spinner"></div>
          <p>Please wait...</p>
        </div>
      ) : (
        pin ? (
          <AuthProvider>
            <IonReactRouter>
            <IonRouterOutlet id="pin">
    
                <Route exact path="/page/pin" component={Pin} />
    
                <IonSplitPane contentId="main">
                  <Menu/>
                  <IonRouterOutlet id="main">
                    
                      <ProtectedRoute key={"1"} path="/page/home" component={Home} />
                      <ProtectedRoute key={"2"} path="/page/settings" component={Settings} />
                      <ProtectedRoute key={"3"} path="/page/about" component={About} />
                      <ProtectedRoute key={"4"} path="/page/login" component={Login} />
                      <ProtectedRoute key={"5"} path="/page/logout" component={Logout} />
                      <ProtectedRoute key={"6"} path="/page/test" component={Test} />
                      <>{console.log("pin url:"+url)}</>
                      <Redirect from="/" to={url} exact />
                      
                    {/* Catch-all redirect to PIN */}
                    <Route>
                      <Redirect to="/page/pin" />
                    </Route>
    
                  </IonRouterOutlet>
                </IonSplitPane>
    
            </IonRouterOutlet>
            </IonReactRouter>
          </AuthProvider>
          ) : (
            <IonReactRouter>
                <IonSplitPane contentId="main">
                  <Menu/>
                  <IonRouterOutlet id="main">
                    
                      <Route key={"1"} path="/page/home" component={Home} />
                      <Route key={"2"} path="/page/settings" component={Settings} />
                      <Route key={"3"} path="/page/about" component={About} />
                      <Route key={"4"} path="/page/login" component={Login} />
                      <Route key={"5"} path="/page/logout" component={Logout} />
                      <Route key={"6"} path="/page/test" component={Test} />
                      <>{console.log("non pin url:"+url)}</>
                      <Redirect from="/" to={url} exact />
    
                  </IonRouterOutlet>
                </IonSplitPane>
            </IonReactRouter>
          )
      )}
    </IonApp>
  );
}


export default App;
